//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { NsExpressiveLink, NsIcon, NsSpinner } from "@nuskin/design-components";
import { StringService } from "@nuskin/ns-util";
import { fromJsonString } from "@nuskin/ns-common-lib";

import NsProductCard from "./NsProductCard.vue";

/**
 * NsProductList
 *
 * Events
 * @event product-update This event fires when a product card's data is updated.
 * Event emits the product: (product) => {}
 */

export default {
  name: "NsProductList",
  components: {
    NsExpressiveLink,
    NsProductCard,
    NsIcon,
    NsSpinner
  },
  props: {
    /**
     * Force the Product Cards to show points
     */
    forcesv: Boolean,
    /**
     * Hide Favorite Button on Product Cards
     */
    hideFavorites: Boolean,
    /**
     * Array of skus for product list. Takes array of strings or objects ([sku] || [{ sku }])
     */
    items: {
      type: [String, Array],
      default: () => []
    },
    /**
     * Link object ({ name, href })
     */
    link: {
      type: [String, Object],
      default: () => ({})
    },
    /**
     * Determines if the product cards should be displayed side-by-side in mobile
     */
    mobileSideBySide: {
      type: Boolean,
      default: true
    },
    /**
     * Title text
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Initial number of products displayed and number added per "Load More" button click. Set to 0 to disable.
     */
    skusPerLoad: {
      type: Number,
      default: 20
    },
    translations: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      skusLimit: this.skusPerLoad,
      loadMoreText: "Load More",
      limitedSkusFrozen: []
    };
  },
  computed: {
    localLink() {
      return fromJsonString(this.link, {});
    },
    skus() {
      const value = fromJsonString(this.items, []);
      return value.map(item => {
        if (typeof item === "object") {
          return item.sku || item.SKU;
        }
        return item;
      });
    },
    limitedSkus() {
      if (this.skusLimit > 0) {
        return this.skus.slice(0, this.skusLimit);
      }
      return this.skus;
    },
    displayedSkus() {
      return this.showSpinner ? this.limitedSkusFrozen : this.limitedSkus;
    },
    showSpinner() {
      return this.$NsProductDataService.batches.some(
        batch =>
          !["success", "failed"].includes(batch.status) &&
          batch.skus.some(batchSku => this.limitedSkus.includes(batchSku))
      );
    },
    showLoadMore() {
      return (
        !this.showSpinner &&
        !!this.skusLimit &&
        this.skusLimit < this.skus.length
      );
    }
  },
  watch: {
    limitedSkus: {
      immediate: true,
      handler(skus) {
        if (!this.$NsProductDataService.check(skus)) {
          this.$NsProductDataService.queue(skus);
        }
      }
    }
  },
  async mounted() {
    await this.setCommonStrings();
  },
  methods: {
    handleProductUpdate(product) {
      this.$emit("product-update", product);
    },
    loadMoreSkus(event) {
      this.limitedSkusFrozen = this.limitedSkus;

      event.target.blur();
      this.skusLimit += this.skusPerLoad;
    },
    async setCommonStrings() {
      if (!this.translations || !this.translations.loadMore) {
        const commonStringKeys = [{ key: "loadMore", dflt: this.loadMoreText }];

        await this.$nextTick();

        try {
          const commonStrings = await StringService.getStrings(
            commonStringKeys
          );
          if (commonStrings && commonStrings.loadMore) {
            this.loadMoreText = commonStrings.loadMore;
          }
        } catch (err) {
          console.warn("Unable to retrieve common translations.", err);
        }
      }
    }
  }
};
